/** @format */

const template = `
<div ng-if="$ctrl.formalRecommendation" class="row recommendation">
  <div class="col-md-6">
    <div class="form-group-mimic">
      <h4 translate="{{'RECOMMENDATION.' + $ctrl.approvalRequestType + '.FORMAL_STATE'}}"></h4>
      <span
        ng-if="$ctrl.formalRecommendation.state === 'NOT_HANDLED'"
        translate="{{'RECOMMENDATION.' + $ctrl.approvalRequestType + '.NOT_HANDLED'}}"></span>
      <span
        ng-if="$ctrl.formalRecommendation.state === 'RECOMMENDED'"
        translate="{{'RECOMMENDATION.' + $ctrl.approvalRequestType + '.RECOMMENDED'}}"></span>
      <span
        ng-if="$ctrl.formalRecommendation.state === 'NOT_RECOMMENDED'"
        translate="{{'RECOMMENDATION.' + $ctrl.approvalRequestType + '.NOT_RECOMMENDED'}}"></span>
    </div>
  </div>
  <div
    class="col-md-6 recommendation-person"
    ng-if="$ctrl.formalRecommendationResponsiblePerson || $ctrl.formalRecommendation.additionalInformation">
    <div class="form-group-mimic">
      <h4 translate="{{'RECOMMENDATION.' + $ctrl.approvalRequestType + '.FORMAL_PERSON'}}"></h4>
      <span>{{$ctrl.formalRecommendationResponsiblePerson}}, {{$ctrl.formalRecommendation.responsiblePersonTitle | localizedString}}</span>
      <span ng-if="$ctrl.formalRecommendation.additionalInformation">{{$ctrl.formalRecommendation.additionalInformation}}</span>
    </div>
  </div>
  <div class="offset-6 col-6" ng-if="$ctrl.formalRecommendation.comment">
    <div class="form-group-mimic">
      <h4 translate="{{'RECOMMENDATION.' + $ctrl.approvalRequestType + '.FORMAL_COMMENT'}}"></h4>
      <span class="text-area-static">{{$ctrl.formalRecommendation.comment}}</span>
    </div>
  </div>
</div>
<div ng-if="$ctrl.contentRecommendation" class="row recommendation">
  <div class="col-md-6">
    <div class="form-group-mimic">
      <h4 translate="{{'RECOMMENDATION.' + $ctrl.approvalRequestType + '.CONTENT_STATE'}}"></h4>
      <span
        ng-if="$ctrl.contentRecommendation.state === 'NOT_HANDLED'"
        translate="{{'RECOMMENDATION.' + $ctrl.approvalRequestType + '.NOT_HANDLED'}}"></span>
      <span
        ng-if="$ctrl.contentRecommendation.state === 'RECOMMENDED'"
        translate="{{'RECOMMENDATION.' + $ctrl.approvalRequestType + '.RECOMMENDED'}}"></span>
      <span
        ng-if="$ctrl.contentRecommendation.state === 'NOT_RECOMMENDED'"
        translate="{{'RECOMMENDATION.' + $ctrl.approvalRequestType + '.NOT_RECOMMENDED'}}"></span>
    </div>
  </div>
  <div
    class="col-md-6 recommendation-person"
    ng-if="$ctrl.contentRecommendationResponsiblePerson || $ctrl.contentRecommendation.additionalInformation">
    <div class="form-group-mimic">
      <h4 translate="{{'RECOMMENDATION.' + $ctrl.approvalRequestType + '.CONTENT_PERSON'}}"></h4>
      <span
        >{{$ctrl.contentRecommendationResponsiblePerson}}, {{$ctrl.contentRecommendation.responsiblePersonTitle | localizedString}}</span
      >
      <span ng-if="$ctrl.contentRecommendation.additionalInformation">{{$ctrl.contentRecommendation.additionalInformation}}</span>
    </div>
  </div>
  <div class="offset-6 col-6" ng-if="$ctrl.contentRecommendation.comment">
    <div class="form-group-mimic">
      <h4 translate="{{'RECOMMENDATION.' + $ctrl.approvalRequestType + '.CONTENT_COMMENT'}}"></h4>
      <span class="text-area-static">{{$ctrl.contentRecommendation.comment}}</span>
    </div>
  </div>
</div>
`;
export default template;
